/**
 * Social Reels - Click-to-Play Video Functionality
 * Handles Shopify video playback for social reel cards
 * Videos only play when user clicks - NO autoplay
 */

/**
 * Initialize social reel video players
 */
function initSocialReelPlayers() {
  const containers = document.querySelectorAll(".js-social-reel__container");

  if (containers.length === 0) {
    return;
  }

  /**
   * Pause all other playing videos and reset their UI
   * @param {HTMLElement} currentContainer - The container of the video that should continue playing
   */
  const pauseAllOtherVideos = currentContainer => {
    containers.forEach(otherContainer => {
      // Skip the current container
      if (otherContainer === currentContainer) {
        return;
      }

      const otherTrigger = otherContainer.querySelector(".js-social-reel__trigger");
      const otherVideoWrapper = otherContainer.querySelector(".js-social-reel__video");
      const otherVideoPlayer = otherContainer.querySelector(".js-social-reel__player");

      if (!otherTrigger || !otherVideoWrapper) {
        return;
      }

      // If video exists and is playing, pause it
      if (otherVideoPlayer) {
        if (otherVideoPlayer instanceof HTMLVideoElement && !otherVideoPlayer.paused) {
          otherVideoPlayer.pause();
          otherVideoPlayer.currentTime = 0;
        }
        // For iframes, we just hide them (can't directly pause without API)
      }

      // Reset UI to show thumbnail
      otherTrigger.style.display = "block";
      otherVideoWrapper.style.display = "none";
    });
  };

  containers.forEach(container => {
    const trigger = container.querySelector(".js-social-reel__trigger");
    const videoWrapper = container.querySelector(".js-social-reel__video");
    const videoTemplate = container.querySelector(".js-social-reel__video-template");
    let videoPlayer = container.querySelector(".js-social-reel__player");

    if (!trigger || !videoWrapper || !videoTemplate) {
      return;
    }

    // Handle click to play video
    const playVideo = e => {
      if (e) e.preventDefault();

      // Pause all other videos before playing this one
      pauseAllOtherVideos(container);

      // If video hasn't been loaded yet, create it from template
      if (!videoPlayer) {
        const templateContent = videoTemplate.content.cloneNode(true);
        const deferredMedia = templateContent.querySelector("deferred-media");

        if (deferredMedia) {
          // Extract the video element from deferred-media's template
          const deferredTemplate = deferredMedia.querySelector("template");
          if (deferredTemplate) {
            const videoContent = deferredTemplate.content.cloneNode(true);
            const videoElement = videoContent.querySelector("video, iframe");

            if (videoElement) {
              // Add our class for identification
              videoElement.classList.add("js-social-reel__player");
              // Ensure video fills container
              if (!videoElement.classList.contains("w-full")) {
                videoElement.classList.add("w-full", "h-full", "object-cover");
              }
              videoWrapper.appendChild(videoElement);
              videoPlayer = videoElement;
            }
          }
        }
      }

      if (!videoPlayer) {
        console.error("Failed to create video player");
        return;
      }

      // Hide thumbnail
      trigger.style.display = "none";
      videoWrapper.style.display = "block";

      // Handle video element (native Shopify videos)
      if (videoPlayer instanceof HTMLVideoElement) {
        // Add ended event listener if not already added (only once per video element)
        if (!videoPlayer.dataset.endedListenerAdded) {
          videoPlayer.addEventListener("ended", () => {
            trigger.style.display = "block";
            videoWrapper.style.display = "none";
            videoPlayer.currentTime = 0;
          });
          videoPlayer.dataset.endedListenerAdded = "true";
        }

        // Play video with sound
        videoPlayer.muted = false;
        videoPlayer.play().catch(error => {
          console.error("Social reel video play failed:", error);
          // Show thumbnail again if play fails
          trigger.style.display = "block";
          videoWrapper.style.display = "none";
        });
      } else if (videoPlayer instanceof HTMLIFrameElement) {
        // For iframes (YouTube/Vimeo), they typically autoplay when loaded
        // The video snippet should handle autoplay for external videos
        // If needed, we can add additional iframe handling here
      }
    };

    // Click event
    trigger.addEventListener("click", playVideo);

    // Keyboard event (Enter or Space)
    trigger.addEventListener("keydown", e => {
      if (e.key === "Enter" || e.key === " ") {
        playVideo(e);
      }
    });
  });
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSocialReelPlayers);
} else {
  initSocialReelPlayers();
}

// Re-initialize when section is rendered (for Shopify theme editor)
document.addEventListener("shopify:section:load", initSocialReelPlayers);
